// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import GlobalStyles from '../../../../../../../../config/styles';

const styles = ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    flex: 1,
    margin: 0,
    textTransform: 'uppercase',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GRAY,
    fontWeight: 600,
    textAlign: 'center',
  },
  text: {
    flex: 1,
    margin: '8px 0 0',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    fontWeight: 600,
    textAlign: 'center',
  }
});

export default styles;
